import {h, KeepAlive} from 'vue'
import {RouterView} from 'vue-router'

export const ToolRoutes = [
  {
    path: '/tool',
    component: {
      render () {
        return h(RouterView, null, {
          default: ({Component}) => h(KeepAlive, null, {
            default: () => h(Component),
          }),
        })
      },
    },
    children: [
      {
        path: 'westard-tracking',
        name: 'WestardTracking',
        component: () => import('@pages/tool-westard-tracking/index.vue'),
        meta: {
          title: '好车西运',
        },
      },
      {
        path: 'gps-trajectory',
        name: 'gps-trajectory',
        component: () => import('@pages/tool-gps-trajectory/index.vue'),
        meta: {
          title: '好车西运',
        },
      },
      {
        path: 'gps-allLocationInfo',
        name: 'gps-allLocationInfo',
        component: () => import('@pages/tool-gps-allLocationInfo/index.vue'),
        meta: {
          title: '在途预览',
        },
      },
    ],
  },
]

